export default __webpack_public_path__ + "static/media/check_ring.f6a4e9c7.svg";